import React from 'react';

import { ImageLightbox, Mosaic } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { ImageBestAnswer } from '../../../types';

export interface AskAiImagesMosaicProps {
    /** array of images with their description, title and altText */
    images: ImageBestAnswer[];
}

/**
 * Provides a mosaic and a slideshow using an array of images
 * @param images array of images that needs to be displayed ask ai answer mosaic
 * @returns a mosaic and a slideshow for ask ai answer with images
 */
export const AskAiImagesMosaic = ({ images }: AskAiImagesMosaicProps) => {
    const { translateKey } = useTranslate();
    const formattedImages = images.map(({ url, title, altText, description }) => ({
        alt: altText || '',
        description,
        image: url,
        title,
    }));
    const { getTriggerProps, imageLightboxProps } = ImageLightbox.useImageLightbox({ images: formattedImages });
    const thumbnails = images.map((image, index) => ({
        image: image.url,
        ...getTriggerProps({ activeImageIndex: index }),
        alt: `${image.altText} - ${translateKey(GLOBAL.OPEN_IMAGE_IN_FULLSCREEN)}`,
    }));

    return (
        <>
            <Mosaic thumbnails={thumbnails} />
            <ImageLightbox
                {...imageLightboxProps}
                aria-label={translateKey(GLOBAL.FULLSCREEN_IMAGE_SLIDESHOW)}
                closeButtonProps={{ label: translateKey(GLOBAL.CLOSE) }}
                slideshowControlsProps={{
                    nextButtonProps: { label: translateKey(GLOBAL.NEXT) },
                    previousButtonProps: { label: translateKey(GLOBAL.PREVIOUS) },
                    paginationItemProps: (index) => ({ label: `Go to slide ${index + 1}` }),
                }}
            />
        </>
    );
};
